import React, { useState, useEffect } from 'react'

import {
  Button,
  TextInput,
  ArrowLeft,
  ArrowRight,
  Icon,
  ArrowToLeft,
  ArrowToRight,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, shape, string } from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

function PaginationCard({
  currentPage,
  totalPages,
  onPageChange: handlePageChange,
  labels = EMPTY_OBJECT,
}) {
  const {
    firstPage = 'Go to first page',
    previousPage = 'Go to previous page',
    nextPage = 'Go to next page',
    lastPage = 'Go to last page',
    pageInput = 'Jump to page',
  } = labels
  const [inputValue, setInputValue] = useState(currentPage)

  useEffect(() => {
    setInputValue(currentPage)
  }, [currentPage])

  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages

  const handleGoToFirstPage = () => {
    if (!isFirstPage) {
      handlePageChange(1)
    }
  }

  const handleGoToPreviousPage = () => {
    if (!isFirstPage) {
      handlePageChange(currentPage - 1)
    }
  }

  const handleGoToNextPage = () => {
    if (!isLastPage) {
      handlePageChange(currentPage + 1)
    }
  }

  const handleGoToLastPage = () => {
    if (!isLastPage) {
      handlePageChange(totalPages)
    }
  }

  const handleInputChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setInputValue(value === '' ? '' : Number(value))
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      let targetPage = Number(inputValue)

      if (targetPage < 1) {
        targetPage = 1
      } else if (targetPage > totalPages) {
        targetPage = totalPages
      }

      setInputValue(targetPage)
      handlePageChange(targetPage)
    }
  }

  const handleBlur = () => {
    if (inputValue === '' || inputValue < 1) {
      setInputValue(currentPage)
    } else if (inputValue > totalPages) {
      setInputValue(totalPages)
    }
  }

  return (
    <div className="shared-pagination__card">
      <Button
        type="secondary"
        disabled={isFirstPage}
        onClick={handleGoToFirstPage}
        customClass="shared-pagination__first-page-btn"
      >
        1
      </Button>
      <Button
        title={firstPage}
        icon={<Icon svgComponent={ArrowToLeft} />}
        type="secondary"
        variant="only-icon"
        disabled={isFirstPage}
        onClick={handleGoToFirstPage}
        customClass="shared-pagination__first-page-btn--mobile"
      />
      <Button
        title={previousPage}
        icon={<Icon svgComponent={ArrowLeft} />}
        type="primary"
        variant="only-icon"
        disabled={isFirstPage}
        onClick={handleGoToPreviousPage}
        customClass="shared-pagination__arrow-btn"
      />
      <TextInput
        id="pagination-page-input"
        inputType="text"
        aria-label={pageInput}
        isPilot
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        size="medium"
        type="primary"
        wrapperClassName="shared-pagination__input-wrapper"
        classNames="shared-pagination__input-field"
        className="shared-pagination__input"
      />
      <Button
        title={nextPage}
        icon={<Icon svgComponent={ArrowRight} />}
        type="primary"
        variant="only-icon"
        disabled={isLastPage}
        onClick={handleGoToNextPage}
        customClass="shared-pagination__arrow-btn"
      />
      <Button
        title={lastPage}
        icon={<Icon svgComponent={ArrowToRight} />}
        type="secondary"
        variant="only-icon"
        disabled={isLastPage}
        onClick={handleGoToLastPage}
        customClass="shared-pagination__last-page-btn--mobile"
      />
      <Button
        type="secondary"
        disabled={isLastPage}
        onClick={handleGoToLastPage}
        customClass="shared-pagination__last-page-btn"
      >
        {totalPages}
      </Button>
    </div>
  )
}

PaginationCard.propTypes = {
  currentPage: number.isRequired,
  totalPages: number.isRequired,
  onPageChange: func.isRequired,
  labels: shape({
    firstPage: string,
    previousPage: string,
    nextPage: string,
    lastPage: string,
    pageInput: string,
  }),
}

export default PaginationCard
